// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!../../vue-loader/lib/style-rewriter.js?id=data-v-7b0a85a6!../../sass-loader/index.js!../../vue-loader/lib/selector.js?type=styles&index=0!./UiIcon.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("291f62d0", content, true);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js!../../vue-loader/lib/style-rewriter.js?id=data-v-7b0a85a6!../../sass-loader/index.js!../../vue-loader/lib/selector.js?type=styles&index=0!./UiIcon.vue", function() {
     var newContent = require("!!../../css-loader/index.js!../../vue-loader/lib/style-rewriter.js?id=data-v-7b0a85a6!../../sass-loader/index.js!../../vue-loader/lib/selector.js?type=styles&index=0!./UiIcon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7b0a85a6!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/keen-ui/src/UiIcon.vue
// module id = 520
// module chunks = 22